import { render, staticRenderFns } from "./EventTicketSettings.vue?vue&type=template&id=26f15ce4&"
import script from "./EventTicketSettings.vue?vue&type=script&lang=js&"
export * from "./EventTicketSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports